import { RoleType } from '@feature/security';

// ADMIN is deliberately absent: the user-documents endpoints answer 403 to it, unlike the wos-isi ones.
export const userDocumentAdminRoles = [
  RoleType.UNIVERSITY_ADMIN,
  RoleType.FACULTY_ADMIN,
  RoleType.DEPARTMENT_ADMIN,
  RoleType.DISCIPLINE_ADMIN,
] as const satisfies readonly RoleType[];

export function isUserDocumentAdminRole(role: RoleType) {
  return (userDocumentAdminRoles as readonly RoleType[]).includes(role);
}
